import styled from "styled-components";

export const SnackbarNotificationTitleDefaultBox = styled.span`

`;